import { updateTenderStatusDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateTenderStatusCallable = getCallable(
  updateTenderStatusDefinition,
);
